/**
 * 주석(하이라이트, 밑줄, 메모) 관련 스타일 컴포넌트
 */
import styled from 'styled-components';

export const HighlightedText = styled.span<{ $color: string; $isAreaSelection: boolean }>`
  ${props => props.$isAreaSelection ? `
    background-color: transparent;
    border: none;
    padding: 0;
    position: relative;
    z-index: 1;
  ` : `
    background-color: ${props.$color};
    border: ${(() => {
      const color = props.$color;
      if (color === '#FFF0F3') return '1px solid #C75355';
      if (color === '#ef4444') return '2px solid #dc2626';
      if (color === '#FFEB3B') return '2px solid #FDD835';
      if (color === '#EBFFCF') return '2px solid #C1DC9B';
      if (color === '#FEFFCF') return '2px solid #E3E4A7';
      if (color === '#E3F2FF') return '2px solid #C2D2E1';
      return '2px solid ' + color;
    })()};
    border-radius: ${props.$color === '#FFF0F3' ? '4px' : '3px'};
    padding: 2px 2px;
  `}
  cursor: pointer;
  position: relative;
  display: inline;
  z-index: 10;
  overflow: visible;
  ${props => !props.$isAreaSelection ? `
    box-decoration-break: clone;
    -webkit-box-decoration-break: clone;
  ` : ''}
  box-sizing: border-box;
  white-space: normal;
  word-break: break-word;
  line-height: inherit;
  max-width: 100%;
  
  &:hover {
    opacity: 0.9;
    ${props => !props.$isAreaSelection ? 'box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);' : ''}
    
    > div[data-inline-note] {
      opacity: 1 !important;
      visibility: visible !important;
    }
  }
  
  @media (max-width: 768px) {
    &:active > div[data-inline-note],
    &[data-note-visible="true"] > div[data-inline-note] {
      opacity: 1 !important;
      visibility: visible !important;
    }
  }

  ${props => !props.$isAreaSelection ? `
    html.dark-mode & {
      color: #2B2B2B !important;
      & * { color: #2B2B2B !important; }
      background-color: ${props.$color};
      border: ${(() => {
        const color = props.$color;
        if (color === '#FFF0F3') return '1px solid #C75355';
        if (color === '#ef4444') return '2px solid #dc2626';
        if (color === '#FFEB3B') return '2px solid #FDD835';
        if (color === '#EBFFCF') return '2px solid #C1DC9B';
        if (color === '#FEFFCF') return '2px solid #E3E4A7';
        if (color === '#E3F2FF') return '2px solid #C2D2E1';
        return '2px solid ' + color;
      })()};
    }
  ` : ''}
`;

export const AreaSelectionOverlay = styled.div<{ $top: number; $left: number; $width: number; $height: number }>`
  position: absolute;
  top: ${props => props.$top}px;
  left: ${props => props.$left}px;
  width: ${props => props.$width}px;
  height: ${props => props.$height}px;
  background-color: #FFF0F3;
  border: 1px solid #C75355;
  border-radius: 4px;
  pointer-events: none;
  z-index: 0;
  box-sizing: border-box;
`;

export const UnderlinedText = styled.span<{ $color: string }>`
  text-decoration: underline;
  text-decoration-color: ${props => props.$color};
  text-decoration-thickness: 4px;
  text-underline-offset: 2px;
  cursor: pointer;
  display: inline;
  white-space: normal;
  word-break: normal;
  line-height: inherit;
  position: relative;
  z-index: 10;

  &:hover {
    opacity: 0.8;
  }
`;

// 강조 표시용 붉은색 점 마커
export const HighlightMarker = styled.div`
  position: absolute;
  top: -6px;
  left: 0;
  width: 12px;
  height: 12px;
  background-color: #ef4444;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  pointer-events: none;
  animation: pulse-marker 1.5s ease-in-out infinite;
  
  @keyframes pulse-marker {
    0%, 100% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.2);
      opacity: 0.8;
    }
  }
`;
